"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_7)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_7`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#00318B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25.9158 18.6231C26.473 17.8561 26.845 16.92 26.845 15.7867V7.36069C26.1164 7.90897 25.229 8.20485 24.3172 8.2035C22.939 8.2035 21.7158 7.54174 20.9467 6.51859C20.1783 7.54174 18.9544 8.2035 17.5762 8.2035C16.6274 8.2035 15.7523 7.88981 15.0485 7.36139V15.7867C15.0485 16.9207 15.4204 17.8568 15.9776 18.6231H25.9158Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.7705 18.3144C17.3438 20.8393 20.9473 21.6842 20.9473 21.6842C20.9473 21.6842 24.5509 20.8393 26.1242 18.3144H15.7705Z",
					fill: "#8DCCFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.8358 12.0849C21.8582 12.1846 22.4477 12.7986 23.0681 13.4989C23.1656 13.6091 22.4547 14.3853 22.5831 14.3825C22.9165 14.374 23.9354 13.1712 23.9403 14.8491C23.9438 15.9677 21.8351 16.7796 21.8351 16.7796H23.061L23.1066 17.8295C23.1066 17.8295 23.4554 16.8933 23.6393 16.6667C24.2077 15.967 25.0554 14.5565 26.0667 14.7649C27.0779 14.9733 25.1081 13.7881 25.1081 13.7881C25.1081 13.7881 24.7431 12.7221 23.941 12.5972C23.2351 12.487 22.9382 12.4211 22.0716 12.0849C21.9537 12.0393 21.7993 11.9221 21.8358 12.0849Z",
					fill: "#D87B00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.2414 13.9432C19.3165 13.8737 19.5544 13.0568 19.8512 12.1691C19.8982 12.0295 20.9256 12.2582 20.8582 12.1481C20.6849 11.8632 19.1333 11.5811 20.5845 10.7389C21.5523 10.1775 23.3087 11.6 23.3087 11.6L22.6968 10.5375L23.5838 9.97403C23.5838 9.97403 22.5979 10.1389 22.3109 10.0926C21.421 9.94947 19.7754 9.9186 19.4512 8.93824C19.127 7.95789 19.0828 10.2568 19.0828 10.2568C19.0828 10.2568 18.3417 11.1046 18.6337 11.8625C18.8905 12.5291 18.9817 12.8196 19.1228 13.7382C19.1431 13.8639 19.1186 14.0561 19.2414 13.9432Z",
					fill: "#D87B00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.7663 15.4295C21.6687 15.3993 20.8428 15.6042 19.9263 15.793C19.7817 15.8224 19.4638 14.8189 19.4021 14.9326C19.2428 15.2253 19.7782 16.7088 18.3207 15.8765C17.3494 15.3214 17.6968 13.0884 17.6968 13.0884L17.0856 14.1509L16.153 13.6667C16.153 13.6667 16.7908 14.4358 16.8947 14.7081C17.2175 15.5495 18.0175 16.9881 17.3326 17.76C16.6477 18.5326 18.6575 17.4161 18.6575 17.4161C18.6575 17.4161 19.7635 17.6316 20.2716 16.9979C20.7193 16.4407 20.9242 16.2161 21.6477 15.633C21.748 15.5544 21.9263 15.4793 21.7663 15.4295Z",
					fill: "#D87B00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 0H10.3789L5.22807 3.43158V0H0.736842V3.43158L-4.41404 0H-6V1.59298L-2.76491 3.74737H-6V8.2386H-2.76491L-6 10.393V12H-4.41404L0.736842 8.54737V12H5.22807V8.54737L10.3789 12H12V10.393L8.72982 8.2386H12V3.74737H8.72982L12 1.59298V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 0H1.85965V4.87018H-6V7.11579H1.85965V12H4.10526V7.11579H12V4.87018H4.10526V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 12V11.207L-1.61404 8.2386H-0.0280704L-5.48772 12H-6ZM-5.48772 0.00701904L-0.0280704 3.74035H-1.61404L-6 0.778949V0.00701904H-5.48772ZM12 0.00701904V0.778949L7.57895 3.74737H5.99298L11.4526 0.00701904H12ZM11.4526 12L5.99298 8.2386H7.57895L12 11.207V12H11.4526Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_7`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AIFlag };
